import { Action, ActionType } from "@redux/actionTypes/finalApprovalActionType";
import { Reducer } from "redux";

export interface IFinalApprovalState {
  finalApprovalDetailsById: any[];
}

const initialState = {
  finalApprovalDetailsById: [],
};

export interface Iheaders {
  headName: string;
  value: string;
  classname?: string;
  separator?: string;
}
export interface ITableData {
  headers: Iheaders[];
  tableData: any;
  totalObject: Record<string, any>[];
}

export const finalApprovalReducer: Reducer<IFinalApprovalState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.FINAL_APPROVAL_DETAILS_BY_PID:
      return {
        ...state,
        finalApprovalDetailsById: action.payload,
      };
    default:
      return state;
  }
};
